module.exports = __webpack_public_path__ + "img/proyecto_15.ed47b53f.png";